import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableHead } from '@mui/material';
import {
  TableCellHeaderStickyTop,
  TableCellHeaderStickyTopAndLeft,
  TableCellStyledWithHeaderTextValueSmall
} from '../../../../components/list/TableComponentsStyled';
import { RoundedHeaderTableRow } from 'components/common/table/TableStyles';

const AuthorizationListResponsiveTableHead = ({ userGroups }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <RoundedHeaderTableRow>
        <TableCellHeaderStickyTopAndLeft>{t('Authorization.Name')}</TableCellHeaderStickyTopAndLeft>
        <TableCellHeaderStickyTop />
        {userGroups?.map(item => {
          return <TableCellStyledWithHeaderTextValueSmall key={item.id}>{item.name}</TableCellStyledWithHeaderTextValueSmall>;
        })}
      </RoundedHeaderTableRow>
    </TableHead>
  );
};
AuthorizationListResponsiveTableHead.propTypes = {
  userGroups: PropTypes.array.isRequired
};

export default AuthorizationListResponsiveTableHead;
